import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="date-picker"
// Wraps a visible dd/mm/yyyy text input with daterangepicker (single-date mode) and
// keeps a hidden field with the ISO value Rails actually submits. Native
// <input type="date"> can't be used here because its displayed field order
// (mm/dd/yyyy vs dd/mm/yyyy) follows the browser/OS locale and can't be
// overridden with HTML or CSS.
export default class extends Controller {
  static targets = ["display", "hidden"]

  connect() {
    const display = this.displayTarget
    const hidden = this.hiddenTarget

    $(display).daterangepicker({
      singleDatePicker: true,
      autoUpdateInput: false,
      showDropdowns: true,
      locale: { format: "DD/MM/YYYY", cancelLabel: "Limpiar" },
      startDate: hidden.value ? moment(hidden.value, "YYYY-MM-DD") : moment()
    })

    $(display).on("apply.daterangepicker", (_event, picker) => {
      display.value = picker.startDate.format("DD/MM/YYYY")
      hidden.value = picker.startDate.format("YYYY-MM-DD")
      hidden.dispatchEvent(new Event("change", { bubbles: true }))
    })

    $(display).on("cancel.daterangepicker", () => {
      display.value = ""
      hidden.value = ""
      hidden.dispatchEvent(new Event("change", { bubbles: true }))
    })
  }

  disconnect() {
    $(this.displayTarget).data("daterangepicker")?.remove()
  }
}
